module.exports = __webpack_public_path__ + "img/calculator.5234ba32.svg";